import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { BlueButton, FlopppyButton } from "../../../ButtonWithLoading";
import { Input, DatePicker, message } from "antd";
import moment from "moment";
import { CheckBoxInput, SelectForm } from "../../../Buttons";
import { getDateFormat } from "../../../../../helpers/Utils";
import Axios from "axios";
import {
  have_product_reference,
  isOrderRowCod,
} from "../../../../../helpers/OrdersFunctionsGlobal";

function SupplyComponent({
  type,
  supplySupplier,
  order_rows,
  orderId,
  postOrderRow,
  mode,
  order_shop_id,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [disabledDates, setDisabledDates] = useState([]);
  const [variables, setVariables] = useState({
    date: "",
    amount: 1,
    product_code: "",
    supplier_id: undefined,
    product_code_boolean: false,
    supplier_code_boolean: false,
    supplier_code: "",
    supplier_selected: undefined,
    supplierCode: false,
    guaranteed_delivery: false,
    spec_order: false,
  });
  const filteredSupplier = supplySupplier?.filter(
    (supplier) => (!/^vv_|^tch_/.test(supplier.name) || /vlantana/i.test(supplier.label))
  );
  useEffect(() => {
    const checkSupplierCode = async () => {
      try {
        if (variables.supplier_id && variables.supplier_selected) {
          const { data } = await Axios.get(
            `/api/v1/additional_suppliers_codes/search?supplier_id=${supplier_id}&product_code=${order_rows.find((e) => e.id == supplier_selected)
              ?.product_reference
            }`
          );
          if (!data || !data.supplier?.is_code) throw new Error("Err");
          return setVariables((prevProps) => ({
            ...prevProps,
            supplier_code: data.supplier_code,
            supplier_code_boolean: true,
          }));
        } else {
          throw new Error("Err");
        }
      } catch (err) {
        console.log(filteredSupplier, "supplySupplier");
        console.error("checkSupplierCode Error: ", err);
        const lookingForSupplier = filteredSupplier.find(
          (item) => item.value === variables.supplier_id
        );

        return setVariables((prevProps) => ({
          ...prevProps,
          supplier_code: "",
          supplier_code_boolean: lookingForSupplier?.is_code || false,
        }));
      }
    };

    if (variables.supplier_id) {
      // oldLogicInputChecker();
      if (variables.supplier_selected) {
        checkSupplierCode();
      }
    }
  }, [variables.supplier_id, variables.supplier_selected]);

  useEffect(() => {
    const fetchDisabledDates = async () => {
      try {
        const { data } = await Axios.get("/api/v1/calendars");
        setDisabledDates(data.map((date) => moment(date, "YYYY-MM-DD")));
      } catch (err) {
        console.error("Error fetching disabled dates: ", err);
      }
    };

    fetchDisabledDates();
  }, []);

  const createNewOrderRow = () => {
    const {
      date,
      amount,
      product_code,
      supplier_id,
      supplier_code_boolean,
      product_code_boolean,
      supplier_code,
      supplier_selected,
      guaranteed_delivery,
      spec_order,
    } = variables;
    if (!supplier_id || !supplier_selected) {
      return message.error("Select a product and a supplier.");
    }
    setLoading(true);
    const resVariables = {
      date,
      amount,
      supplier_id,
      supplier_code,
      guaranteed_delivery,
      spec_order,
    };
    if (product_code_boolean) {
      resVariables.product_code = product_code;
    }
    if (supplier_code_boolean) {
      resVariables.supplier_code = supplier_code;
    }

    let func;
    if (type == "OrderBulkAction") {
      func = postOrderRow(resVariables, orderId, supplier_selected);
    } else {
      func = dispatch(postOrderRow(resVariables, orderId, supplier_selected));
    }
    func.then((res) => {
      if (res.success) {
        setVariables({
          date: "",
          amount: 1,
          product_code: "",
          supplier_id: undefined,
          supplier_code_boolean: false,
          supplier_code: "",
          supplier_selected: undefined,
          supplierCode: false,
          guaranteed_delivery: false,
          spec_order: false,
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };
  const handleSupplyBlock = (name, value) => {
    setVariables({
      ...variables,
      [name]: value,
    });
  };

  const {
    date,
    amount,
    product_code,
    supplier_id,
    supplier_code_boolean,
    product_code_boolean,
    supplier_selected,
    supplier_code,
    guaranteed_delivery,
    spec_order,
  } = variables;
  const selectedProduct = order_rows.find((e) => e.id == supplier_selected);
  console.log(variables, "variables");
  return (
    <div className={type == "OrderBulkAction" ? "" : "col-12 bg-silver"}>
      <div className="d-flex pt-3">
        <span style={{ width: "15%" }}>
          <Input
            type="number"
            min={0}
            disabled={mode === "Servisas"}
            value={amount}
            onChange={(e) => handleSupplyBlock("amount", e.target.value)}
          />
        </span>
        <span
          className="d-flex justify-content-center align-items-center"
          style={{ width: "5%" }}
        >
          *
        </span>
        <span style={{ width: "25%" }}>
          <SelectForm
            options={order_rows
              .filter((e) => {
                if (!have_product_reference(e.product_reference)) return false;
                if (order_shop_id && isOrderRowCod(e.id_product, order_shop_id))
                  return false;
                return true;
              })
              .map((e) => ({
                value: e.id,
                label: e.product_name
                  ? `${e.product_reference} — ${e.product_name}`
                  : e.product_reference,
              }))}
            onlyPlaceholder="Products"
            name="supplier_selected"
            value={supplier_selected}
            onChange={(e) => handleSupplyBlock("supplier_selected", e)}
            dropdownMatchSelectWidth={false}
          />
        </span>
        <span
          className="d-flex justify-content-center align-items-center"
          style={{ width: "5%" }}
        >
          <CheckBoxInput
            checked={product_code_boolean}
            onChange={() =>
              handleSupplyBlock("product_code_boolean", !product_code_boolean)
            }
          />
        </span>
        <span className="pr-1" style={{ width: "25%" }}>
          <SelectForm
            options={filteredSupplier}
            onlyPlaceholder="Suppliers"
            name="supplier_id"
            value={supplier_id}
            onChange={(e) => handleSupplyBlock("supplier_id", e)}
            dropdownMatchSelectWidth={false}
          />
        </span>
        <span className="pl-1" style={{ width: "25%" }}>
          <DatePicker
            style={{ width: "100%" }}
            placeholder="Date"
            disabledDate={(d) => {
              let dateNow = moment();
              if (+dateNow.format("HH") >= 16) {
                return (
                  !d ||
                  d.isBefore(dateNow.add(1, "days").format("YYYY-MM-DD")) ||
                  disabledDates.some((disabledDate) =>
                    d.isSame(disabledDate, "day")
                  )
                );
              } else {
                return (
                  !d ||
                  d.isBefore(dateNow.format("YYYY-MM-DD")) ||
                  disabledDates.some((disabledDate) =>
                    d.isSame(disabledDate, "day")
                  )
                );
              }
            }}
            value={getDateFormat(date)}
            onChange={(e, arg) => handleSupplyBlock("date", arg)}
          />
        </span>
      </div>
      {(product_code_boolean || supplier_code_boolean) && selectedProduct && (
        <div className="d-flex mt-2">
          <span style={{ width: "20%" }}></span>
          <span
            style={{ fontSize: 12, fontWeight: 600, color: "#8c8c8c" }}
            title={selectedProduct.product_name}
          >
            {selectedProduct.product_reference}
            {selectedProduct.product_name
              ? ` — ${selectedProduct.product_name}`
              : ""}
          </span>
        </div>
      )}
      {(product_code_boolean || supplier_code_boolean) && (
        <div className="d-flex mt-3">
          <span style={{ width: "20%" }}></span>
          <span style={{ width: "25%" }}>
            {product_code_boolean && (
              <Input
                placeholder="ID"
                value={product_code}
                onChange={(e) =>
                  handleSupplyBlock("product_code", e.target.value)
                }
              />
            )}
          </span>
          <span style={{ width: "5%" }}></span>
          <span></span>
          {supplier_code_boolean && (
            <span style={{ width: "25%" }}>
              <Input
                placeholder="ID"
                value={supplier_code}
                onChange={(e) =>
                  handleSupplyBlock("supplier_code", e.target.value)
                }
              />
            </span>
          )}
        </div>
      )}
      <div className="d-flex justify-content-between align-items-center mt-3 pb-3">
        <span
          className="d-flex justify-content-between align-items-center"
          // className="pl-1 pt-2 pb-3 d-flex justify-content-between align-items-center"
          style={{ width: "100%" }}
        >
          <div className="d-flex">
            <CheckBoxInput
              text="SPEC order"
              checked={spec_order}
              onChange={() =>
                setVariables((prev) => ({
                  ...prev,
                  spec_order: !prev.spec_order,
                }))
              }
            />
            <CheckBoxInput
              text="Guaranteed delivery"
              checked={guaranteed_delivery}
              onChange={() =>
                setVariables((prev) => ({
                  ...prev,
                  guaranteed_delivery: !prev.guaranteed_delivery,
                }))
              }
            />
          </div>
          <div>
            {type == "OrderBulkAction" ? (
              <BlueButton loading={loading} onClick={() => createNewOrderRow()}>
                Add supply
              </BlueButton>
            ) : (
              <FlopppyButton
                loading={loading}
                onClick={() => createNewOrderRow()}
              />
            )}
          </div>
        </span>
      </div>
    </div>
  );
}

export default SupplyComponent;
